export default __webpack_public_path__ + "appstore_badge_fi.svg";